import { IFlagsConfig, IUser } from '@/models';
import {
  POPUP_ACTION_ID,
  POPUP_CONTENT_ID,
  PopupActionType,
  showPopupMessage,
} from '@/store/reducers';
import { shouldShowTermsUpdatedModal } from '@/utils/helpers/opt-in';
import { cookiesUtils } from '@/utils/storage/cookies';
import { COOKIE_KEYS } from '@/constants/storage/cookies';
import { GROWTH_BOOK } from '@/constants/features/feature-flag';

type DispatchShowPopup = (action: ReturnType<typeof showPopupMessage>) => void;

export const showTermsUpdatedModalIfNeeded = (
  flagsConfig: IFlagsConfig,
  user: IUser,
  installedTime: number,
  getFeatureValue: (key: string, fallback: boolean) => boolean,
  dispatch: DispatchShowPopup
): void => {
  const isOnboarding = cookiesUtils.getBooleanCookie(
    COOKIE_KEYS.SHOW_NEW_SITE_ONBOARDING
  );
  // Eligibility first — getFeatureValue enrolls via GrowthBook trackingCallback.
  if (
    !shouldShowTermsUpdatedModal(flagsConfig, user, isOnboarding, installedTime)
  ) {
    return;
  }
  const termsUpdatedEnabled = getFeatureValue(
    GROWTH_BOOK.FEATURES.OPTIN_TERMS_UPDATED_MODAL,
    false
  );
  if (!termsUpdatedEnabled) {
    return;
  }
  dispatch(
    showPopupMessage({
      contentId: POPUP_CONTENT_ID.TERMS_UPDATED,
      buttonAction: { type: PopupActionType.CLOSE },
      actionId: POPUP_ACTION_ID.EULA_AGREED,
      showCloseButton: true,
    })
  );
};
